import React from 'react';
import { BookOpenIcon, FileTextIcon, TrendingUpIcon, HeartIcon, BrainIcon, SparklesIcon, ActivityIcon, EyeIcon, ThermometerIcon, LeafIcon, ExternalLinkIcon } from 'lucide-react';
export function Blog() {
  const featuredArticles = [{
    icon: ThermometerIcon,
    title: 'Integrative Approaches to Diabetes Management',
    description: 'Evidence-based acupuncture protocols supporting glycemic control and neuropathy relief',
    category: 'Clinical Research',
    color: 'blue'
  }, {
    icon: ActivityIcon,
    title: 'Master Tung Acupuncture Case Series',
    description: 'Rapid pain relief outcomes in chronic musculoskeletal disorders',
    category: 'Case Studies',
    color: 'teal'
  }, {
    icon: ActivityIcon,
    title: 'Dr. Tan Balance Method Insights',
    description: 'Simplified meridian balancing techniques for acute and chronic pain',
    category: 'Technique Analysis',
    color: 'purple'
  }, {
    icon: BrainIcon,
    title: 'Scalp Acupuncture in Neurorehabilitation',
    description: 'Clinical outcomes in stroke recovery and paralysis reversal',
    category: 'Neurological Recovery',
    color: 'indigo'
  }, {
    icon: SparklesIcon,
    title: 'Cosmetic Acupuncture for Natural Rejuvenation',
    description: 'Mechanisms of collagen stimulation and facial muscle modulation',
    category: 'Aesthetic Medicine',
    color: 'pink'
  }, {
    icon: HeartIcon,
    title: 'Fertility Enhancement Through Acupuncture',
    description: 'Preconception care and IVF support with clinical data',
    category: 'Reproductive Health',
    color: 'rose'
  }, {
    icon: EyeIcon,
    title: 'TCM Tongue Diagnosis Workshops',
    description: 'Detailed pattern differentiation guides and photographic case reviews',
    category: 'Diagnostic Methods',
    color: 'green'
  }, {
    icon: ActivityIcon,
    title: 'Pulse Diagnosis Masterclass Summaries',
    description: 'Interpreting classical and modern pulse qualities for precise treatment planning',
    category: 'Diagnostic Methods',
    color: 'emerald'
  }, {
    icon: LeafIcon,
    title: 'Herbal Medicine Integration',
    description: 'Complementary herbal formulations supporting acupuncture therapies',
    category: 'Integrative Therapies',
    color: 'lime'
  }];
  const categories = [{
    name: 'Clinical Research',
    count: 12,
    icon: TrendingUpIcon
  }, {
    name: 'Case Studies',
    count: 24,
    icon: FileTextIcon
  }, {
    name: 'Technique Analysis',
    count: 18,
    icon: ActivityIcon
  }, {
    name: 'Patient Education',
    count: 15,
    icon: BookOpenIcon
  }, {
    name: 'Diagnostic Methods',
    count: 10,
    icon: EyeIcon
  }];
  return <div className="w-full bg-white" data-id="element-298">
      <section className="bg-gradient-to-br from-blue-50 to-teal-50 py-16 px-4 w-full" data-id="element-299">
        <div className="max-w-7xl mx-auto text-center" data-id="element-300">
          <BookOpenIcon className="w-16 h-16 text-blue-600 mx-auto mb-6" data-id="element-301" />
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-302">
            Research, Articles & Blog
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8" data-id="element-303">
            Explore in-depth writings and case studies on integrative medicine
          </p>
          <a href="https://aiimr.in/blogs" target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors shadow-lg" data-id="element-304">
            Visit Our Blog
            <ExternalLinkIcon className="w-5 h-5 ml-2" data-id="element-305" />
          </a>
        </div>
      </section>
      <section className="py-16 px-4 w-full" data-id="element-306">
        <div className="max-w-7xl mx-auto" data-id="element-307">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-308">
            Featured Articles & Research
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-309">
            {featuredArticles.map((article, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-gray-100" data-id="element-310">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-100 to-teal-100 rounded-lg flex items-center justify-center mb-4" data-id="element-311">
                  <article.icon className="w-6 h-6 text-blue-600" data-id="element-312" />
                </div>
                <div className="mb-3" data-id="element-313">
                  <span className="text-xs font-semibold text-blue-600 bg-blue-50 px-3 py-1 rounded-full" data-id="element-314">
                    {article.category}
                  </span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-315">
                  {article.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4" data-id="element-316">
                  {article.description}
                </p>
                <a href="https://aiimr.in/blogs" target="_blank" rel="noopener noreferrer" className="text-blue-600 font-medium hover:underline inline-flex items-center" data-id="element-317">
                  Read More
                  <ExternalLinkIcon className="w-4 h-4 ml-1" data-id="element-318" />
                </a>
              </div>)}
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-gray-50 w-full" data-id="element-319">
        <div className="max-w-7xl mx-auto" data-id="element-320">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-321">
            Browse by Category
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6" data-id="element-322">
            {categories.map((category, index) => <a key={index} href="https://aiimr.in/blogs" target="_blank" rel="noopener noreferrer" className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow text-center" data-id="element-323">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4" data-id="element-324">
                  <category.icon className="w-6 h-6 text-blue-600" data-id="element-325" />
                </div>
                <h3 className="font-semibold text-gray-900 mb-2" data-id="element-326">
                  {category.name}
                </h3>
                <p className="text-sm text-gray-600" data-id="element-327">
                  {category.count} Articles
                </p>
              </a>)}
          </div>
        </div>
      </section>
      <section className="py-16 px-4 w-full" data-id="element-328">
        <div className="max-w-4xl mx-auto" data-id="element-329">
          <div className="bg-gradient-to-br from-blue-600 to-teal-600 rounded-2xl p-8 text-white text-center" data-id="element-330">
            <BookOpenIcon className="w-16 h-16 mx-auto mb-6" data-id="element-331" />
            <h2 className="text-3xl font-bold mb-4" data-id="element-332">
              Stay Updated with Our Latest Research
            </h2>
            <p className="text-lg mb-8 opacity-90" data-id="element-333">
              Subscribe to our newsletter for the latest articles, case studies,
              and integrative medicine insights delivered to your inbox
            </p>
            <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto" data-id="element-334">
              <input type="email" placeholder="Enter your email" className="flex-1 px-6 py-4 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-white" data-id="element-335" />
              <button className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors" data-id="element-336">
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>;
}